import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Loader2, CheckCircle2, AlertCircle } from "lucide-react";
import { useAccepterInvitation } from "@/hooks/useInvitations";

function InviteAccept() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";
  const accepter = useAccepterInvitation();

  const [nom, setNom] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    accepter.mutate(
      { token, nom: nom.trim() || undefined },
      {
        onSuccess: () => setDone(true),
        onError: (err: any) =>
          setError(err?.response?.data?.message || "Cette invitation n'est plus valide."),
      }
    );
  };

  if (!token) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background px-4">
        <p className="text-sm text-muted-foreground">Lien d'invitation invalide ou incomplet.</p>
      </div>
    );
  }

  if (done) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background px-4">
        <div className="max-w-sm text-center space-y-3">
          <CheckCircle2 className="mx-auto h-10 w-10 text-verified" />
          <h1 className="text-lg font-semibold text-foreground">Compte activé</h1>
          <p className="text-sm text-muted-foreground">
            Votre compte a été créé. Vous pouvez maintenant vous connecter avec votre email.
          </p>
          <button
            onClick={() => navigate("/redaction/login")}
            className="mt-2 rounded-md bg-foreground px-4 py-2 text-sm font-semibold text-background"
          >
            Aller à la connexion
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <form onSubmit={handleSubmit} className="w-full max-w-sm space-y-4 rounded-md border border-border bg-card p-6">
        <div>
          <h1 className="text-lg font-semibold text-foreground">Activer votre compte</h1>
          <p className="text-xs text-muted-foreground">Confirmez votre nom pour finaliser votre inscription.</p>
        </div>
        {error && (
          <div className="flex items-center gap-2 rounded-md bg-alert/10 border border-alert/30 px-3 py-2 text-xs text-alert">
            <AlertCircle className="h-3.5 w-3.5 shrink-0" /> {error}
          </div>
        )}
        <div className="space-y-1.5">
          <label className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Nom</label>
          <input
            value={nom}
            onChange={(e) => setNom(e.target.value)}
            placeholder="Votre nom complet"
            className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
          />
        </div>
        <button
          type="submit"
          disabled={accepter.isPending}
          className="flex w-full items-center justify-center gap-2 rounded-md bg-foreground px-4 py-2 text-sm font-semibold text-background disabled:opacity-60"
        >
          {accepter.isPending ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
          Activer mon compte
        </button>
      </form>
    </div>
  );
}

export default InviteAccept;
